import { render, staticRenderFns } from "./CostImporterBankStatementList.vue?vue&type=template&id=55e04ffa&"
import script from "./CostImporterBankStatementList.vue?vue&type=script&lang=js&"
export * from "./CostImporterBankStatementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports